import "bootstrap";
import "./animations/index";

/**
 * 
 * GSAP
*/
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import "./custom-actions/gsap";

/**
 * 
 * SwiperJS
*/
import "./components/CustomSwiper/index.js"; // js is being used with custom block: /inc/custom-blocks/carousel-block